import number1 from "../../../../assets/img/product/ebp-1.svg"
import number2 from "../../../../assets/img/product/ebp-2.svg"
import number3 from "../../../../assets/img/product/ebp-3.svg"
export default function ProductExplanation(){
    return(
        <div className="container-perusahaan-mitra">
            <div className="blue-section">
                <p className='m-0'>
                    Danai.id telah bekerjasama dengan <b>lebih dari 50 mitra perusahaan/UKM</b> dalam memberikan fasilitas produk-produk pembiayaan. Beberapa fasilitas yang banyak digunakan oleh para Mitra kami antara lain:
                </p>
            </div>
            <div className="penjelasan-produk">
                <div className="produk-ebp">
                    <img className="produk-image" src={require('../../../../assets/img/product/perusahaan-mitra1.png')}
                         alt='produk-ebp'/>
                    <div className="text-section">
                        <h2 className="text-header">Fasilitas Kesejahteraan Karyawan</h2>
                        <p className="mb-4">Beberapa keuntungan dari perusahaan jika memiliki Fasilitas Kesejahteraan
                            Karyawan <em>(Employee Benefit Program)</em> antara lain:</p>
                        <ul className="p-0 text-[#272727]">
                            <li className="flex flex-row p-0 gap-2 items-center mb-2">
                                <img className="number" src={number1} alt="number-1"/>
                                Memiliki program atau fasilitas kesejahteraan bagi karyawan
                            </li>
                            <li className="flex flex-row p-0 gap-2 items-center mb-2">
                                <img className="number" src={number2} alt="number-2"/>
                                Meningkatkan kinerja karyawan
                            </li>
                            <li className="flex flex-row p-0 gap-2 items-center mb-2">
                                <img className="number" src={number3} alt="number-3"/>
                                Meningkatkan daya saing perusahaan dalam merekrut dan mempertahankan karyawan
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="produk-multiguna">
                    <img className="produk-image" src={require('../../../../assets/img/product/perusahaan-mitra2.png')}
                         alt='produk-multiguna'/>
                    <div className="text-section">
                        <h2 className="text-header">Pembiayaan Modal Usaha (Multiguna)</h2>
                        <p>
                            Perusahaan dapat membantu pemasok <em>(supplier/vendor)</em> dan kontraktor mereka dengan
                            bekerjasama dengan Danai.id dengan memberikan fasilitas pembiayaan untuk modal usaha.
                            <br/><br/>
                            Dengan kerjasama ini, para supplier atau kontraktor dapat mengajukan permohonan pembiayaan
                            yang didasarkan pada tagihan ataupun kontrak kerja.
                            <br/><br/>
                            Pembayaran tagihan atas pembiayaan dan kontrak kerja ini akan dibayarkan langsung oleh
                            perusahaan / pemberi kerja untuk melunasi pinjaman dari <em>supplier/vendor</em> tersebut.
                            <br/><br/>
                            Dengan cara seperti ini, perusahaan akan lebih terjamin atas kinerja dari supplier/vendor
                            dan dapat menciptakan membentuk rantaian pemasok/<em>supplier</em> atau <em>vendor</em> yang
                            dapat diandalkan dan dipercaya.
                        </p>
                    </div>
                </div>
                <div className="produk-inventory">
                    <img className="produk-image" src={require('../../../../assets/img/product/perusahaan-mitra3.png')}
                         alt='produk-inventory'/>
                    <div className="text-section">
                        <h2 className="text-header">Pembiayaan Persediaan <em>(Inventory Financing)</em></h2>
                        <p>
                            Danai.id bekerjasama / bermitra dengan perusahaan-perusahaan Pergudangan
                            / <em>Fullfilment</em> (terutama
                            Perusahaan Pergudangan yang memiliki Layanan Berbasis Teknologi) untuk memberikan fasilitas
                            modal usaha kepada Pelanggan-Pelanggan yang menggunakan jasa pergudangan.
                            <br/><br/>
                            Keuntungan untuk Mitra adalah dapat menarik lebih banyak pelanggan untuk bergabung atau
                            menyimpan persediaan di gudang dikarenakan akan mendapatkan kemudahan akses / prioritas
                            untuk mendapatkan fasilitas Pembiayaan Modal Usaha.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}